export enum AnswerOptionEnum {
  Anull,
  Clean,
}
